import { useState, useEffect, } from "react";
import { Modal, OverlayTrigger, Popover } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import { Button, Table } from "reactstrap";
import iconImage from "../../../../../assets/download.jpg";
import { faImages, faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import WarningMessage from "../../../../common/warnMsg";
import CommonUtils from "../../../../common/commonUtiles";
// import httpCommon from "../../../../../services/http.common";
import httpService from "../../../../../services/http.service";
import { TimeOverLaping } from "../../cloudDashboard";
import validator from "validator";
import SuccessMessage from "../../../../common/successMsg";
import { key } from "fontawesome";
import "./addEditChannleForm.css";
import ErrorMessage from "../../../../common/errorMsg";
import NasPop from "../../../../rightcolumn/NasSelectModalWindow/nasPop";
import TimePicker from "../../../../common/TimePicker";


export function AddEditChannleForm({
  show1,
  handleClose1,
  data,
  setFormData,
  array1,
  timeZone,
  formName,
}) {
  function isAfterNow(time) {
    return new Date(time).getTime() > new Date().getTime();
  }
  const NasUser = localStorage.getItem('UserId')
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [array2, setArray2] = useState([]);
  const [selectedPropertyValues, setSelectedPropertyValues] = useState([]);
  const [PropertyDataObject, setPropertyDataObject] = useState();
  const [loading, setLoading] = useState(false);
  const [showPicker, setShowPicker] = useState(false)
  const [files, setFiles] = useState()
  const [value, setValue] = useState("00:00")
  const [selectedFiles, setSelectedFiles] = useState({});


  const hideLoader = () => {
    setLoading(false);
  };

  let checkTimeOverLaping = () => {
    return TimeOverLaping(data.billboard);
  };


  useEffect(async () => {
    let dataUserPost = { userID: localStorage.getItem("UserId") };
    console.log(dataUserPost, "getallpropertybyuser");
    let LayoutArraydata = await httpService
      .CreateUpdate("getallpropertybyuser", dataUserPost)
      .catch((err) => {
        return;
      });

    const arr2 = [];
    console.log(LayoutArraydata?.data?.propertyData, "getallpropertybyuserq");

    for (let i = 0; i < LayoutArraydata?.data?.propertyData.length; i++) {
      console.log(LayoutArraydata?.data?.propertyData, "getallpropertybyuserq");
      let obj = {
        PropertyId: `${LayoutArraydata?.data?.propertyData[i]._id}`,
        value: `${LayoutArraydata?.data?.propertyData[i].Name}`,
        label: `${LayoutArraydata?.data?.propertyData[i].Name}`,
        count: `${LayoutArraydata?.data?.propertyData[i].count}`,
      };
      if (LayoutArraydata?.data?.propertyData[i]) {
        console.log(obj, "getallpropertybyuserq");
        {
          arr2.push(obj);
        }
      }
    }
    setArray2(arr2);
    setPropertyDataObject(LayoutArraydata?.data?.propertyData);

    // setArray2(LayoutArraydata)

    console.log(LayoutArraydata, "getallpropertybyuser");
  }, [show1]);

  const saveProgram = async () => {
    if (data.PropertyType.length === 0) {
      WarningMessage("Please Select Property Name");
      return;
    } else if (!data.channelName) {
      WarningMessage("Please Enter Channel Name");
      return;
    } else if (!data.channelID) {
      WarningMessage("Please Enter Channel ID");
      return;
    } else if (data.videoSource.length === 0) {
      WarningMessage("Please Select atleast one Videosource");
      return;
    }
    // if(checkTimeOverLaping()) return
    if (data.videoSource[0] == "billboard") {
      console.log(data.billboard);
      if (data.billboard.length === 0) {
        WarningMessage("Please  Add  Billboards  Time !");
        return;
      }
      if (
        (data.billboard[0].billboard_name == "" &&
          data.billboard[0].billboard == "") ||
        (data.billboard[data.billboard.length - 1].billboard_name == "" &&
          data.billboard[data.billboard.length - 1].billboard == "")
      ) {
        WarningMessage("Please  Choose Layout OR Input Url !");
        return;
      } else if (data.billboard[0].Timezone == "") {
        WarningMessage("Please  Select  Time Zone !");
        return;
      }
    }
    if (data.videoSource[0] == "billboard" && checkTimeOverLaping()) return;

    let UserId = `${localStorage.getItem("UserId")}`;
    let datas = {
      data: data,
      UserId: UserId,
    };
    let flag = false;

    if (datas.data.videoSource[0] == "billboard") {
      console.log(data, "billboard");
      let validTimeForBillboardScheduling =
        await CommonUtils.validateBillboardScheduling(data);
      if (validTimeForBillboardScheduling) {
        return;
      }
    }

    let validTimeForProgram = await CommonUtils.bilboardProgramTimeValidation(
      data
    );
    if (validTimeForProgram) {
      return;
    }

    let data1 = datas.data.channelName
      .trim()
      .split("  ")
      .filter((word) => word !== "");
    datas.data.channelName = data1.join(" ");
    if (
      datas.data.videoSource[0] === "encoder" ||
      datas.data.videoSource[0] == "url"
    ) {
      if (!validator.isURL(datas.data.videoSource[1])) {
        hideLoader();
        WarningMessage("Please enter a  valid Url !");
        return;
      }
      if (
        datas.data.videoSource[1].substring(0, 7) != "http://" &&
        datas.data.videoSource[1].substring(0, 8) != "https://"
      ) {
        hideLoader();
        WarningMessage(
          "Please enter a valid Url with proper http or https header!"
        );
        return;
      }
    }
    const returndata = await httpService
      .CreateUpdate("getInfoapi", datas)
      .catch((err) => {
        return;
      });

    handleClose1();
    // loadAlldata();

    hideLoader();
    if (returndata.data.message === "Successful") {
      SuccessMessage("Channel Added Successfully");
      return;
    } else if (returndata.data.message) {
      WarningMessage(returndata.data.message);
      return;
    }
  };

  const UpdateChannelinfo = async () => {
    if (data.PropertyType.length === 0) {
      WarningMessage("Please Select Property Name");
      return;
    } else if (!data.channelName) {
      WarningMessage("Please Enter Channel Name");
      return;
    } else if (!data.channelID) {
      WarningMessage("Please Enter Channel ID");
      return;
    } else if (data.videoSource.length === 0) {
      WarningMessage("Please Select atleast one Videosource");
      return;
    }
    if (data.videoSource[0] == "billboard") {
      console.log(data.billboard);
      if (data.billboard.length === 0) {
        WarningMessage("Please Schedule the time !");
        return;
      }
      if (
        (data.billboard[0].billboard_name == "" &&
          data.billboard[0].billboard == "") ||
        (data.billboard[data.billboard.length - 1].billboard_name == "" &&
          data.billboard[data.billboard.length - 1].billboard == "")
      ) {
        WarningMessage("Please  Choose Layout OR Input Url !");
        return;
      } else if (data.billboard[0].Timezone == "") {
        WarningMessage("Please  Select  Time Zone !");
        return;
      }
    }
    if (data.videoSource[0] == "billboard" && checkTimeOverLaping()) return;
    let datas = {
      id1: data._id,
      program: data,
    };

    if (datas.program.videoSource[0] == "billboard") {
      let validTimeForBillboardScheduling =
        await CommonUtils.validateBillboardScheduling(data);
      if (validTimeForBillboardScheduling) {
        return;
      }
    }

    let validTimeForProgram = await CommonUtils.bilboardProgramTimeValidation(
      data
    );
    if (validTimeForProgram) {
      return;
    }

    let data1 = datas.program.channelName
      .trim()
      .split("  ")
      .filter((word) => word !== "");
    datas.program.channelName = data1.join(" ");
    if (
      datas.program.videoSource[0] === "encoder" ||
      datas.program.videoSource[0] === "url"
    ) {
      if (!validator.isURL(datas.program.videoSource[1])) {
        hideLoader();
        WarningMessage("Please enter a  valid Url !");
        return;
      }
      if (
        datas.program.videoSource[1].substring(0, 7) != "http://" &&
        datas.program.videoSource[1].substring(0, 8) != "https://"
      ) {
        hideLoader();
        WarningMessage(
          "Please enter a valid Url with proper http or https header!"
        );
        return;
      }
    }
    const res = await httpService
      .CreateUpdate("UpdateChannelRow", datas)
      .catch((err) => {
        return;
      });
    // showLoader();
    handleClose1();

    // setShow1(false);
    // loadAlldata();
    if (res.data.message === "Successful") {
      SuccessMessage("Channel updated successfully");
      hideLoader();
    } else if (res.data.message) {
      WarningMessage(res.data.message);
      hideLoader();
    }
  };

  const handlePropertySelect = (selectedValue) => {
    if (Number(selectedValue[selectedValue.length - 1].count) > 5) {
      let b =
        selectedValue[selectedValue.length - 1].label +
        " Property cannot be added because it already has 6 Channels.";
      WarningMessage(b);
      return;
    } else {
      setSelectedPropertyValues(selectedValue);
      let arrSelect = [];
      for (let i = 0; i < selectedValue?.length; i++) {
        for (let j = 0; j < array2.length; j++) {
          if (
            selectedValue[i].value === array2[j].value &&
            selectedValue[i].PropertyId === array2[j].PropertyId
          ) {
            let obj = {
              value: `${array2[j].value}`,
              label: `${array2[j].label}`,
              PropertyId: `${array2[j].PropertyId}`,
            };
            arrSelect.push(obj);
          }
        }
      }
      let ChannelData = { ...data };
      ChannelData.PropertyType = arrSelect;
      setFormData(ChannelData);
    }

    // if (selectedValue?.length > 0 && !idsNotInArray && (checkPreFiledProperty < 1 || checkPreFiledProperty == null)) {
    //   let a = (selectedValue[selectedValue.length - 1].label + " Property cannot be added because it already has 6 Channels.")
    //   WarningMessage(a)
    //   return;
    // } else {

    // }
  };

  const Deletebillboarddata = async (event, i) => {
    console.log(data);
    let ChannelData = { ...data };
    ChannelData.billboard.splice(i, 1);
    setFormData(ChannelData);
  };

  const DeleteConfirmationDialog = async (msg, titileMsg, event, item) => {
    Swal.fire({
      title: titileMsg,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        // if (msg === "property") {
        //   DeleteProperty(event, item)
        // } else if (msg === "rule") {
        // DeleteRule(event, item)
        // } else if (msg === "Channel") {
        // DeleteChannelRow(event, item);
        // }
        if (msg === "billboard") {
          Deletebillboarddata(event, item);
        }
      }
    });
  };

  let baseImage = "";
  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const getFile = async (e) => {
    const file = e.target.files[0];
    console.log(file, "file", e.target);
    if (file) {
      await getBase64(file)
        .then((result) => {
          baseImage = result;
          let data1 = { ...data };
          data1.programIcon = baseImage;
          setFormData(data1);
        })
        .catch((err) => {
          return;
        });
    }
  };

  const onInputChange1 = (e) => {
    setFormData({ ...data, [e.target.name]: e.target.value });
  };

  const handleC = (e) => {
    let ChannelData = { ...data };
    ChannelData.channel_category = e.target.value;
    setFormData(ChannelData);
  };

  const handleC1 = (e) => {
    let ChannelData = { ...data };
    ChannelData.channel_language = e.target.value;
    setFormData(ChannelData);
  };


  const handleStartTime = (e, i) => {
    if (e) {
      let ChannelData = { ...data };
      ChannelData.program[i].startTime = e.substring(0, 5);
      setFormData(ChannelData);
      if (ChannelData.program[i].endTime) {
        let startTime = e;
        let startHour =
          parseInt(startTime.split(":")[0]) +
          parseInt(startTime.split(":")[1]) / 60;
        let endTime = ChannelData.program[i].endTime;
        let endHour =
          parseInt(endTime.split(":")[0]) +
          parseInt(endTime.split(":")[1]) / 60;
        if (endHour >= startHour) {
          let duration = Math.round((endHour - startHour) * 60);
          ChannelData.program[i].duration = duration;
        } else {
          let duration = Math.round((endHour - startHour + 24) * 60);
          ChannelData.program[i].duration = duration;
        }
      }
    }
  };

  const handleChangeProgram = (e, i, name) => {
    let ChannelData = { ...data };
    ChannelData.program[i][`${name}`] = e;
    setFormData(ChannelData);
  };

  const handleEndTime = (e, i) => {
    if (e) {
      let ChannelData = { ...data };
      ChannelData.program[i].endTime = e.substring(0, 5);
      setFormData(ChannelData);
      if (ChannelData.program[i].startTime) {
        let endTime = e;
        let startTime = ChannelData.program[i].startTime;

        let startHour =
          parseInt(startTime.split(":")[0]) +
          parseInt(startTime.split(":")[1]) / 60;
        let endHour =
          parseInt(endTime.split(":")[0]) +
          parseInt(endTime.split(":")[1]) / 60;
        if (endHour >= startHour) {
          let duration = Math.round((endHour - startHour) * 60);
          ChannelData.program[i].duration = duration;
        } else {
          let duration = Math.round((endHour - startHour + 24) * 60);
          ChannelData.program[i].duration = duration;
        }
      }
    }
  };

  const handlebillboardendtime = (elem, i) => {
    const dateObj = new Date(elem);
    const hhmm = dateObj.toTimeString().slice(0, 5);
    if (elem) {
      let ChannelData = { ...data };
      ChannelData.billboard[i].endTime = hhmm;
      setFormData(ChannelData);
      // if(ChannelData.billboard[i].endTime > 12){
      //   elem.toLocaleString('en-US', { hour: 'numeric', hour12: true })
      // }
      if (ChannelData.billboard[i].startTime) {
        let endTime = hhmm;
        let startTime = ChannelData.billboard[i].startTime;

        let startHour =
          parseInt(startTime.split(":")[0]) +
          parseInt(startTime.split(":")[1]) / 60;
        let endHour =
          parseInt(endTime.split(":")[0]) +
          parseInt(endTime.split(":")[1]) / 60;
        if (endHour >= startHour) {
          let duration = Math.round((endHour - startHour) * 60);
          ChannelData.billboard[i].duration = duration;
        } else {
          let duration = Math.round((endHour - startHour + 24) * 60);
          ChannelData.billboard[i].duration = duration;
        }
      }
    }
  };

  const handlebillboardstarttime = (elem, i) => {
    const dateObj = new Date(elem);
    const hhmm = dateObj.toTimeString().slice(0, 5);
    if (elem) {
      let ChannelData = { ...data };
      ChannelData.billboard[i].startTime = hhmm;
      setFormData(ChannelData);
      // if(ChannelData.billboard[i].startTime > 12){
      //   elem.toLocaleString('en-US', { hour: 'numeric', hour12: true , minute: 'numeric' })
      // }

      if (ChannelData.billboard[i].endTime) {
        let startTime = hhmm;
        let startHour =
          parseInt(startTime.split(":")[0]) +
          parseInt(startTime.split(":")[1]) / 60;
        let endTime = ChannelData.billboard[i].endTime;
        let endHour =
          parseInt(endTime.split(":")[0]) +
          parseInt(endTime.split(":")[1]) / 60;
        if (endHour >= startHour) {
          let duration = Math.round((endHour - startHour) * 60);
          ChannelData.billboard[i].duration = duration;
        } else {
          let duration = Math.round((endHour - startHour + 24) * 60);
          ChannelData.billboard[i].duration = duration;
        }
      }
    }
  };

  const DeleteAllBillboards = async () => {
    let ChannelData = { ...data };
    ChannelData.billboard = [];
    setFormData(ChannelData);
  };

  const ischecked = (event) => {
    if (event.target.value === "billboard") {
      let ChannelData = { ...data };
      ChannelData.videoSource[0] = event.target.value;
      ChannelData.videoSource[1] = "";
      setFormData(ChannelData);
      if (ChannelData.billboard.length == 0) {
        addbillboard();
      }
    }
    if (event.target.value === "url") {
      let ChannelData = { ...data };
      ChannelData.videoSource[0] = event.target.value;
      ChannelData.videoSource[1] = "";
      setFormData(ChannelData);
      DeleteAllBillboards();
    }
    if (event.target.value === "encoder") {
      let ChannelData = { ...data };
      ChannelData.videoSource[0] = event.target.value;
      ChannelData.videoSource[1] = "";
      setFormData(ChannelData);
      DeleteAllBillboards();
    }
  };

  const handletimezoneChange = (e, i, name) => {
    // console.log(e,"time zone seletct")
    // let ChannelData = { ...onClickData };
    // ChannelData.billboard[i][`${name}`] = e;
    // setOnclickData(ChannelData);
    let ChannelData = { ...data };
    if (name === 'Timezone')
      ChannelData.billboard.forEach(ele => ele[`${name}`] = e);
    else
      ChannelData.billboard[i][`${name}`] = e;
    setFormData(ChannelData);
  };
  // const selectedPropertyValues =()=>{
  const handlelayoutTypechange = (e, i, name, type) => {
    let ChannelData = { ...data };
    ChannelData.billboard[i][`${name}`] = type;
    setFormData(ChannelData);
  }

  const addbillboard = async () => {
    let ChannelData = { ...data };
    ChannelData.billboard.push({
      billboard: "",
      billboard_name: "",
      startTime: "00:00",
      endTime: "23:59",
      Timezone: "",
    });
    setFormData(ChannelData);
  };

  const addprogram = async () => {
    let ChannelData = { ...data };
    ChannelData.program.push({
      title: "",
      language: "",
      duration: 0,
      startTime: "00:00",
      endTime: "00:00",
      description: "",
    });
    setFormData(ChannelData);
  };

  const handleChangeBillboard = (e, i, name, billboard_name) => {
    let linknamechange = e.value;
    //let flag1 = e.innerText;
    let label = linknamechange.split(" (")[0].trim();
    let linkValue1 = linknamechange.split(" (")[1].trim();
    let linkValue = linkValue1.split(")")[0];
    let ChannelData = { ...data };
    ChannelData.billboard[i][`${name}`] = linkValue;
    ChannelData.billboard[i][`${billboard_name}`] = label;
    console.log("channeldata", ChannelData);
    setFormData(ChannelData);
  };
  // useEffect(() => {
  //   setOnclickData(data)

  // }, [data])

  // }

  const getNasFile = async (data) => {
    let res = await httpService.get(`/show-user-bucket-files?userID=${NasUser}`)

    console.log("Res getNasFile : ", res.data.files)
      if (data.format === "image") {
        const allImageFiles = res.data.files.filter((item) => {
          const fileSplit = item.name.split(".")[1].toLowerCase();
          return data.type.includes(fileSplit);
        });
        if (allImageFiles.length === 0) {
          WarningMessage("There is no image file. Please upload it first.");
          return
        }
        setFiles(allImageFiles);
      }
  };

  const handleOpenPickerLocalServer = () => {
    const data = {
      type: ["png", "jpg", "jpeg", "gif", "bmp", "webp", "svg"],
      format: "image",
    };
    setShowPicker(true);
    getNasFile(data);
  };
  const handleSelectFile = (fileName) => {
    setSelectedFiles((prevSelected) => ({
      ...prevSelected,
      [fileName]: !prevSelected[fileName],
    }));
  };

  const handleLocalSubmit = () => {
    const selected = Object.keys(selectedFiles).filter(
      (fileName) => selectedFiles[fileName]
    );

    let name = selected[0]?.replace(",", "/");
    const URL = `${window.location.origin}/api/v1/gcp-asset-file?userId=${NasUser}&filePath=${name}`
    let data1 = { ...data };
    data1.programIcon = URL;
    setFormData(data1);

    setShowPicker(false);
    setSelectedFiles({});
  }

  const [isOpen, setIsOpen] = useState(false);

  const togglePopover = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Modal size="lg" show={show1} onHide={handleClose1}>
        <Modal.Header closeButton>
          <Modal.Title>
            {/* {console.log(onClickData, "onClickData")} */}
            {formName} Channel
          </Modal.Title>
        </Modal.Header>
        <div className="ui main">
          <form className="ui form row">
            <div className="field position-relative">

              <label style={{ fontSize: "14px" }}>
                Property<i style={{ color: "red" }}>*</i>
              </label>

              <Select
                isMulti
                name="Property"
                options={array2}
                defaultValue={data?.PropertyType}
                onChange={handlePropertySelect}
                className="basic-multi-select"
                classNamePrefix="select"
                value={data?.PropertyType}
              />
              <p className="mt-1">
                <span className="font-weight-bold">Note:-</span> Properties having
                less than 6 Channels can be selected{" "}
              </p>
            </div>
            <div className="field position-relative">
              <label style={{ fontSize: "14px" }}>
                Channel Name<i style={{ color: "red" }}>*</i>
              </label>
              <input
                type="text"
                name="channelName"
                placeholder="Channel Name"
                maxLength={100}
                onKeyDown={(e) => {
                  if (e.target.selectionStart === 0 && e.key === " ") {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  onInputChange1(e);
                }}
                value={data?.channelName}
              />
            </div>
            <div className="field position-relative">
              <label style={{ fontSize: "14px" }}>
                Channel ID<i style={{ color: "red" }}>*</i>
              </label>
              <input
                type="text"
                name="channelID"
                placeholder="Channel ID"
                onChange={(e) => {
                  if (e.target.value.match(/[^A-Za-z0-9]/)) {
                    return;
                  }
                  onInputChange1(e);
                }}
                value={data?.channelID}
              />
            </div>
            <div className="field col-6" style={{ paddingRight: "3px" }}>
              <label>Channel Language</label>
              <select
                className="form-control"
                value={data?.channel_language}
                name="channel_language"
                onChange={(event) => handleC1(event)}
              >
                <option value="">Select Language</option>
                <option value="English">English</option>
                <option value="Spanish">Spanish</option>
                <option value="Portuguese">Portuguese</option>
                <option value="French">French</option>
                <option value="Dutch">Dutch</option>
              </select>
            </div>
            <div className="field col-6" style={{ paddingLeft: "3px" }}>
              <label>Channel Category</label>
              <select
                className="form-control"
                value={data?.channel_category}
                name="channel_category"
                onChange={(event) => handleC(event)}
              >
                <option value="">Select Category</option>
                <option value="Bulletin Board">Bulletin Board</option>
                <option value="Live">Live</option>
                <option value="Security">Security</option>
                <option value="VOD">VOD</option>
                <option value="Schedules">Schedules</option>
                <option value="Activities">Activities</option>
              </select>
            </div>
            <div className="field">
              <label style={{ fontSize: "14px" }}>Channel Description </label>
              <textarea
                type="text"
                name="channelDescription"
                placeholder="Channel Description"
                onChange={(e) => onInputChange1(e)}
                value={data?.channelDescription}
              />
            </div>

            <div className="field col-6">
              <label style={{ fontSize: "14px" }}>Icon</label>

              <div class="input-group row">
                <div classNmae="input-group-prepend"></div>
                <div
                  className="custom-file col-8"
                  style={{ display: "flex", flexDirection: "column", gap: 4 }}
                >
                  <input
                    type="file"
                    id="myfile"
                    name="myfile"
                    accept="image/*"
                    onChange={(e) => getFile(e)}
                  />
                  <Button
                    className="form-control"
                    color="primary"
                    onClick={handleOpenPickerLocalServer}
                  >
                    <div className="" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
                      <div className="">Cloud Storage</div>
                    </div>
                  </Button>
                </div>
                <div
                  className="col-4"
                  style={{
                    height: 80,
                    width: 100,
                    margin: "0px 4px",
                    backgroundColor: "black",
                  }}
                >
                  {data?.programIcon != "" ? (
                    <img
                      src={data?.programIcon}
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "cover",
                      }}
                      alt="image"
                    />
                  ) : (
                    <img
                      src={iconImage}
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "cover",
                      }}
                      alt="image"
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="field col-6">
              <label style={{ fontSize: "14px" }}>
                Video Source<i style={{ color: "red" }}>*</i>
              </label>
              <div className="form-check form-check-inline">
                <input
                  type="radio"
                  className="form-check-input radio-button"
                  id="1"
                  value="billboard"
                  name="videoSource"
                  onChange={(event) => ischecked(event)}
                  checked={
                    data?.videoSource && data?.videoSource[0] === "billboard"
                      ? true
                      : false
                  }
                />
                <label className="form-check-label">Billboard</label>
              </div>
              {/* <div className="form-check form-check-inline">
                <input
                  type="radio"
                  className="form-check-input radio-button"
                  id="2"
                  value="encoder"
                  name="videoSource"
                  onChange={(e) => ischecked(e)}
                  checked={
                    data?.videoSource && data?.videoSource[0] === "encoder"
                      ? true
                      : false
                  }
                />
                <label className="form-check-label">Encoder</label>
              </div> */}
              <div className="form-check form-check-inline">
                <input
                  type="radio"
                  className="form-check-input radio-button"
                  id="3"
                  value="url"
                  name="videoSource"
                  onChange={(e) => ischecked(e)}
                  checked={
                    data?.videoSource && data?.videoSource[0] === "url"
                      ? true
                      : false
                  }
                />
                <label
                  className="form-check-label"
                  style={{ paddingBottom: "15px" }}
                >
                  URL
                </label>
              </div>

              {/* {data?.videoSource &&
                data?.videoSource[0] === "encoder" ? (
                <div>
                  <input
                    type="text"
                    name="encoder"
                    value={data?.videoSource[1]}
                    placeholder="Encoder"
                    onChange={(event) => {
                      let ChannelData = { ...data };
                      ChannelData.videoSource[1] = event.target.value;
                      setFormData(ChannelData);
                    }}
                  ></input>
                </div>
              ) : (
                " "
              )} */}
              {data?.videoSource &&
                data?.videoSource[0] === "url" ? (
                <div className="dropdown">
                  <input
                    type="text"
                    placeholder="Url"
                    name="url"
                    value={data.videoSource[1]}
                    onChange={(event) => {
                      let ChannelData = { ...data };
                      ChannelData.videoSource[1] = event.target.value;
                      setFormData(ChannelData);
                    }}
                  ></input>
                </div>
              ) : (
                " "
              )}
            </div>
            {/* // for multiple billboard  */}
            <div
              hidden={data?.videoSource &&
                data?.videoSource[0] == "encoder"
                || data?.videoSource &&
                data?.videoSource[0] == "url"}
              className="row"
              style={{ marginTop: "25px", marginBottom: "10px" }}
            >
              <div className="col-11 program-header">
                <b>Billboards</b>
              </div>
              <div
                className="col-1 text-right"
                style={{
                  color: "#337ab7",
                  fontSize: "large",
                  fontWeight: "bold",
                  marginBottom: "10px",
                  cursor: "pointer",
                }}
              >
                <span onClick={(event) => {
                  addbillboard();
                }}>Add{" "}
                  <FontAwesomeIcon
                    className="icon"
                    icon={faPlusSquare}
                    style={{ paddingleft: "5px" }} />
                </span>
              </div>
              {data &&
                data?.billboard &&
                data?.billboard.map((elem, i) => {
                  console.log("elem?.startTime : ", elem?.startTime)
                  console.log("elem?.endTime : ", elem?.endTime)

                  return (
                    <div
                      className="row"
                      style={{ backgroundColor: "#f2f2f2", padding: "9px 5px" }}
                    >
                      <div className="col-2" style={{ padding: "2px", marginTop: "-8px" }}>
                        <label>
                          <b>Starts At</b>
                        </label>
                        {/* 
                        <input
                          type="time"
                          format="HH:mm"
                          name="ProgramSchedule"
                          onChange={(event) => handlebillboardstarttime(event.target.value, i)}
                          value={elem?.startTime}
                        /> */}

                        <TimePicker defaultValue={elem?.startTime} onValueChange={(value) => handlebillboardstarttime(value, i)} />
                        {/* <DatePicker
                          selected={
                            elem?.startTime
                              ? (() => {
                                const [hours, minutes] = elem.startTime.split(":");
                                const date = new Date();
                                date.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
                                return date;
                              })()
                              : null
                          }
                          onChange={(time) => handlebillboardstarttime(time, i)}
                          showTimeSelect
                          showTimeSelectOnly
                          timeFormat="HH:mm"
                          timeIntervals={15}
                          filterTime={isAfterNow}
                          dateFormat="h:mm aa"
                          className="datepicker-input"
                        /> */}


                      </div>

                      <div className="col-2" style={{ padding: "2px", marginTop: "-8px" }}>
                        <label>
                          <b>Ends At</b>
                        </label>

                        {/* <input
                          type="time"
                          format="HH:mm"
                          name="ProgramSchedule"
                          onChange={(event) => handlebillboardendtime(event.target.value, i)}
                          value={elem?.endTime} */}

                        <TimePicker defaultValue={elem?.endTime} onValueChange={(value) => handlebillboardendtime(value, i)} />
                        {/* <DatePicker
                          selected={
                            elem?.endTime
                              ? (() => {
                                const [hours, minutes] = elem.endTime.split(":");
                                const date = new Date();
                                date.setHours(parseInt(hours), parseInt(minutes), 0, 0);
                                return date;
                              })()
                              : null
                          }
                          onChange={(time) => handlebillboardendtime(time, i)}
                          showTimeSelect
                          showTimeSelectOnly
                          timeFormat="HH:mm"
                          timeIntervals={15}
                          filterTime={isAfterNow}
                          dateFormat="h:mm aa"
                          className="datepicker-input"
                        /> */}
                      </div>

                      <div className="col-3" style={{ padding: "5px", marginTop: "-10px" }}>
                        <label>
                          <b>Timezone</b>
                        </label>
                        <select
                          onChange={(event) => {
                            handletimezoneChange(event.target.value, i, "Timezone");
                          }}
                          className="form-control"
                          value={data?.billboard[i]?.Timezone}
                        >
                          {timeZone?.map(element => <option value={element?.value}>{element?.label}</option>
                          )}
                        </select>
                      </div>

                      {newFunction(i, handlelayoutTypechange, data, handleChangeBillboard, elem, array1, handletimezoneChange)}

                      <div className="col text-center d-flex align-items-center" style={{ marginTop: "6px", marginLeft: "7px" }}>
                        <label>
                          <b></b>
                        </label>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={(event) => {
                            event.preventDefault();
                            // Deletebillboarddata(i)
                            DeleteConfirmationDialog("billboard", "Are you sure want to delete this billboard?", event, i);

                          }}
                        >
                          <i className="trash icon me-0"></i>
                        </button>{" "}
                      </div>
                    </div>
                  );
                })}
            </div>
            <div
              hidden={data?.videoSource &&
                data?.videoSource[0] === "billboard"}
              className="row"
              style={{ marginTop: "25px", marginBottom: "10px" }}
            >
              <div className="col-11 program-header">
                <b>Programs</b>
              </div>
              <div
                className="col-1 text-right"

                style={{
                  color: "#337ab7",
                  fontSize: "large",
                  fontWeight: "bold",
                  marginBottom: "10px",
                  cursor: "pointer",
                }}
              >
                <span onClick={() => {
                  addprogram();
                }}>Add{" "}
                  <FontAwesomeIcon
                    className="icon"
                    icon={faPlusSquare}
                    style={{ paddingleft: "5px" }} /></span>

              </div>

              {data &&
                data?.program &&
                data?.program.map((elem, i) => {
                  return (
                    <div
                      className="row"
                      style={{ backgroundColor: "#f2f2f2", padding: "15px" }}
                    >
                      <div className="col-4" style={{ padding: "5px" }}>
                        <label>
                          <b>Title</b>
                        </label>
                        <input
                          name={`title_${i}`}
                          className="form-control"
                          placeholder="Title of Program"
                          onChange={(event) => handleChangeProgram(event.target.value, i, "title")}
                          value={elem.title}
                        />
                      </div>

                      <div className="col-4" style={{ padding: "5px" }}>
                        <label>
                          <b>Language</b>
                        </label>
                        <select
                          className="form-control"
                          value={elem.language}
                          name={`programLanguage_${i}`}
                          onChange={(event) => handleChangeProgram(
                            event.target.value,
                            i,
                            "language"
                          )}
                        >
                          <option value="">Select Language</option>
                          <option value="English">English</option>
                          <option value="Spanish">Spanish</option>
                          <option value="Portuguese">Portuguese</option>
                          <option value="French">French</option>
                          <option value="Dutch">Dutch</option>
                        </select>
                      </div>

                      <div className="col-4" style={{ padding: "5px" }}>
                        <label>
                          <b>Duration</b>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name={`duration_${i}`}
                          placeholder="Duration"
                          value={elem.duration}
                          readOnly />
                      </div>

                      <div className="col-2" style={{ padding: "5px" }}>
                        <label>
                          <b>Starts At</b>
                        </label>
                        <input
                          type="time"
                          format="HH:mm"
                          name="ProgramSchedule"
                          onChange={(event) => handleStartTime(event.target.value, i)}
                          value={elem.startTime}
                        />
                      </div>

                      <div className="col-2" style={{ padding: "5px" }}>
                        <label>
                          <b>Ends At</b>
                        </label>
                        <input
                          type="time"
                          format="HH:mm"
                          name="ProgramSchedule"
                          onChange={(event) => handleEndTime(event.target.value, i)}
                          value={elem.endTime}
                        />
                      </div>

                      <div className="col-8" style={{ padding: "5px" }}>
                        <label>
                          <b>Description</b>
                        </label>
                        <input
                          name={`programDescription_${i}`}
                          placeholder="Description"
                          onChange={(event) => handleChangeProgram(
                            event.target.value,
                            i,
                            "description"
                          )}
                          value={elem.description}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
            <div></div>
          </form>
        </div>
        <Modal.Footer>
          <Button
            className="btn btn-success"
            onClick={() => {
              if ("Add" === formName) { saveProgram(); }
              if ("Edit" === formName) { UpdateChannelinfo(); }
            }}
          //   onClick={handleClose1.handleClose1}
          //   onClick={() => {
          //     if (save) {
          //       saveProgram();
          //       setPropertyVal([]);
          //       setSelectedPropertyValues([]);
          //     } else {
          //       UpdateChannelinfo();
          //       setPropertyVal([]);
          //     }
          //   } }
          > {formName == "Add" ? "Add" : "Update"}
            {/* {save ? "save" : "update"} */}
          </Button>
          <Button
            className="btn btn-danger"
            onClick={handleClose1}

          //   onClick={() => {
          //     setSelectedPropertyValues([]);
          //     setShow1(false);
          //   } }
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      <NasPop
        showPicker={showPicker}
        files={files}
        selectedFiles={selectedFiles}
        handleSelectFile={handleSelectFile}
        handleNASSubmit={handleLocalSubmit}
        setShowPicker={setShowPicker}
      />
    </>
  );
}

function newFunction(i, handlelayoutTypechange, data, handleChangeBillboard, elem, array1, handletimezoneChange) {
  return <div className="col-4" style={{ padding: "5px", marginTop: "-10px" }}>
    <b>Choose Layout </b>
    <input name={"layout" + i} type="radio" value="layout" id={"layout" + i} className="radio-button"
      onChange={(event) => {
        handlelayoutTypechange(event.target.value, i, "layoutType", "layout");
      }}
      checked={data?.billboard[i] && data?.billboard[i].layoutType ? data?.billboard[i].layoutType == "layout" ? true : false : false} />
    <b style={{ paddingLeft: "15px" }}>Input Url </b>
    <input name={"url" + i} type="radio" id={"url" + i} value="url" className="radio-button"
      onChange={(event) => {
        handlelayoutTypechange(event.target.value, i, "layoutType", "url");
      }}
      checked={data?.billboard[i] && data?.billboard[i].layoutType ? data?.billboard[i].layoutType == "url" ? true : false : false} />
    <select
      onChange={(event) => {
        handleChangeBillboard(event.target, i, "billboard", "billboard_name");
      }}
      className="form-control"
      value={`${elem.billboard_name} (${elem.billboard})`}
      hidden={data?.billboard[i] && data?.billboard[i].layoutType ? data?.billboard[i].layoutType != "layout" : true}
    >
      <option value="">Choose Layout</option>
      {array1?.map((optelem) => {
        return (
          <option value={optelem?.value}>{optelem?.label}</option>
        );
      })}
    </select>
    <input
      type="text"
      placeholder="Layout Url"
      name="url"
      value={data?.billboard[i] && data?.billboard[i].billboard ? data?.billboard[i].billboard : ""}
      hidden={data?.billboard[i] && data?.billboard[i].layoutType ? data?.billboard[i].layoutType != "url" : true}
      onChange={(event) => {
        handletimezoneChange(event.target.value, i, "billboard");
      }}
    ></input>
  </div>;
}
